import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Card } from "@amzn/stencil-react-components/card";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { useIntl } from "react-intl";

export interface ChatbotBannerProps {
  onLaunch: () => void;
}

/** Blue Aiva bot icon — copied from AivaApertureMfe AivaIcon.tsx (blue variant). */
export function AivaIcon({ size = 48 }: { size?: number }): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      <rect
        x="0.5"
        y="0.5"
        width="43"
        height="43"
        rx="21.5"
        fill="rgb(112, 55, 163)"
      />
      <path
        d="M35 21.5V23.7347C35 25.2317 34.8208 26.8158 33.7778 27.8896C31.4237 30.3134 26.8555 31 22 31C17.1445 31 12.5763 30.3134 10.2222 27.8896C9.1792 26.8158 9 25.2317 9 23.7347V21.5C9 21.3323 9.00595 21.1656 9.0177 21H9V14.5C9 14.2239 9.22386 14 9.5 14C9.77614 14 10 14.2239 10 14.5V17.8397C11.9612 14.4101 16.5955 12 22 12C27.4045 12 32.0388 14.4101 34 17.8397V14.5C34 14.2239 34.2239 14 34.5 14C34.7761 14 35 14.2239 35 14.5V21H34.9823C34.9941 21.1656 35 21.3323 35 21.5Z"
        fill="#F1F4F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23C12 20.7909 13.7909 19 16 19H28C30.2091 19 32 20.7909 32 23C32 25.2091 30.2091 27 28 27H16C13.7909 27 12 25.2091 12 23ZM17 23.5C17 24.3284 16.3284 25 15.5 25C14.6716 25 14 24.3284 14 23.5C14 22.6716 14.6716 22 15.5 22C16.3284 22 17 22.6716 17 23.5ZM28.5 25C29.3284 25 30 24.3284 30 23.5C30 22.6716 29.3284 22 28.5 22C27.6716 22 27 22.6716 27 23.5C27 24.3284 27.6716 25 28.5 25Z"
        fill="rgb(112, 55, 163)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="43"
        height="43"
        rx="21.5"
        stroke="rgb(112, 55, 163)"
      />
    </svg>
  );
}

/** Banner prompting the user to open the AI chatbot. Colors match Aiva ActiveSessionBanner (#f0ecf5). */
export function ChatbotBanner({ onLaunch }: ChatbotBannerProps): JSX.Element {
  const intl = useIntl();

  return (
    <Card
      padding="S300"
      backgroundColor="#f0ecf5"
      borderRadius="dimensions.radius.300"
      dataTestId="chatbot-banner"
    >
      <Row alignItems="center" justifyContent="space-between" gridGap="S300">
        <Col gridGap="S200" flex={1}>
          <Text fontSize="T200" fontWeight="bold">
            {intl.formatMessage({ id: "chatbot-banner-title" })}
          </Text>
          <Text fontSize="T200" color="color.neutral.70">
            {intl.formatMessage({ id: "chatbot-banner-message" })}
          </Text>
          <Row>
            <Button
              variant={ButtonVariant.Secondary}
              onClick={onLaunch}
              dataTestId="chatbot-banner-launch-btn"
            >
              {intl.formatMessage({ id: "chatbot-header-title" })}
            </Button>
          </Row>
        </Col>
        <View flexShrink={0}>
          <AivaIcon />
        </View>
      </Row>
    </Card>
  );
}
